import React from 'react'
import { Maybe } from 'graphql/jsutils/Maybe'
import { AlertFilledIcon, CheckFilledIcon, RolledIcon, WarningFilledIcon } from 'transfix-icons'
import { REQUIRED_INSURANCE_POLICY_TYPES } from '../constants'

interface IStatusIcon {
  status: Maybe<string>
  isType: Maybe<string>
}

const StatusIcon = ({ isType, status }: IStatusIcon) => {
  // Only show icons for required insurance policy types
  if (!isType || !REQUIRED_INSURANCE_POLICY_TYPES.includes(isType)) {
    return null
  }

  switch (status) {
    case 'active':
      return <CheckFilledIcon color='green3' />
    case 'pending':
      return <AlertFilledIcon color='warning' />
    case 'pending_active':
      return <RolledIcon color='coolGray5' />
    case 'rejected':
      return <WarningFilledIcon color='error' />
    default:
      return <AlertFilledIcon color='warning' />
  }
}

export default StatusIcon
